var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64248 0H13.011L20.9415 8.27394V24.3575C20.9415 26.3694 19.3109 28 17.299 28H3.64248C1.6306 28 0 26.3694 0 24.3575V3.64248C0 1.63064 1.6306 0 3.64248 0Z",
    fill: "#96005C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0V8.20598H20.9418L13 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80096 20V15.6364H2.85565V17.3878H4.57511V15.6364H5.62766V20H4.57511V18.2464H2.85565V20H1.80096ZM6.14648 16.4929V15.6364H9.83469V16.4929H8.51154V20H7.47177V16.4929H6.14648ZM10.3498 15.6364H11.6559L12.7638 18.3381H12.815L13.9229 15.6364H15.229V20H14.2021V17.3196H14.1658L13.1175 19.9723H12.4613L11.413 17.3047H11.3768V20H10.3498V15.6364ZM15.8869 20V15.6364H16.9416V19.1435H18.7569V20H15.8869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlFile);
export default __webpack_public_path__ + "static/media/html_file.373056380b114a43f2c62fb924a3dd24.svg";
export { ForwardRef as ReactComponent };